import { Reveal } from "@/components/Reveal";

const PageHero = ({ eyebrow, title, description, testid }) => (
  <section className="relative overflow-hidden bg-[#EFF6FF] pt-32 pb-16 sm:pt-40 sm:pb-20">
    <div
      className="blob-float absolute -top-24 -right-24 h-72 w-72 rounded-full bg-sky-200/50 blur-3xl"
      aria-hidden="true"
    />
    <div
      className="blob-float absolute -bottom-32 -left-16 h-80 w-80 rounded-full bg-[#FF6B6B]/10 blur-3xl"
      style={{ animationDelay: "-6s" }}
      aria-hidden="true"
    />
    <div className="container-site relative">
      <Reveal>
        <span className="eyebrow">{eyebrow}</span>
        <h1
          data-testid={testid}
          className="mt-4 max-w-3xl text-4xl sm:text-5xl lg:text-6xl font-extrabold tracking-tight leading-[1.08] text-[#0F2C59]"
        >
          {title}
        </h1>
        {description && (
          <p className="mt-6 max-w-2xl text-base sm:text-lg leading-relaxed text-slate-600">
            {description}
          </p>
        )}
      </Reveal>
    </div>
  </section>
);

export default PageHero;
